import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=a8de0b62"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=a8de0b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports